import { getCategoryStats } from "helpers/constants/translate";
import { useTranslation } from "next-i18next";
import React from "react";
import { AiFillInstagram } from "react-icons/ai";
import { FaFacebook } from "react-icons/fa";

type SocialMediaStatsPropsType = {
  category: any;
};

function SocialMediaStats({ category }: SocialMediaStatsPropsType) {
  const { t: translate } = useTranslation("categories_carousel");
  const { t: categoriesTranslate } = useTranslation("categories");
  const stats = getCategoryStats(category);
  return (
    <div>
      <div className="flex items-center rtl:flex-row-reverse ">
        <FaFacebook size={30} className="p-[5px] rounded-full  zoom-icon text-[#1877F2] " />
        <div className="flex flex-row gap-1 rtl:flex-row-reverse">
          <span>+{categoriesTranslate(stats?.fb)}</span>
          <span>{translate("facebook_pages")}</span>
        </div>
      </div>
      <div className="flex items-center rtl:flex-row-reverse">
        <AiFillInstagram size={30} className="text-[#CA0D8A] p-1 rounded-full  zoom-icon" />
        <div className="flex flex-row gap-1 rtl:flex-row-reverse">
          <span>+{categoriesTranslate(stats?.instagram)}</span>
          <span>{translate("instagram_pages")}</span>
        </div>
      </div>
    </div>
  );
}

export default SocialMediaStats;
